import {isAustria} from '@/helpers/utils/main';

class PricePrinter {
    constructor(project) {
        this.project = project; 
    }

    print(price) { 
        return isAustria(this.project) ? `€${price}`: `${price} €`; 
    } 
}

export default PricePrinter;